import { Box, styled } from '@mui/system';

export const SIDE_PANEL_WIDTH = 728;

export const SidePanelContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

export const SidePanelHeader = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: '16px 28px',
}));

export const SidePanelTitle = styled(Box)(() => ({
  fontSize: '16px',
  fontWeight: 500,
  color: '#303c42',
}));

export const SidePanelSubtitle = styled(Box)(() => ({
  fontSize: '14px',
  color: '#6B7280',
  marginTop: '4px',
}));

export const SidePanelCloseButton = styled('button')(() => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
}));

export const SidePanelScrollArea = styled(Box)(() => ({
  flex: 1,
  overflowY: 'auto',
  padding: '0 28px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
}));

export const SidePanelFooter = styled(Box)(() => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: 'white',
  boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.05)',
  padding: '18px 24px',
  display: 'flex',
  // Centred, like the contract detail panel's footer.
  justifyContent: 'center',
  gap: '16px',
}));

// -- Sections: same look as the contract detail panel's SectionCard / SectionTitle / SectionDivider --
export const SidePanelSectionCard = styled(Box)(() => ({
  backgroundColor: 'white',
  borderRadius: '8px',
  boxShadow: '2px 2px 10px 0px rgba(48,60,66,0.08)',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const SidePanelSectionTitle = styled(Box)(() => ({
  fontSize: '18px',
  fontWeight: 500,
  color: '#303c42',
}));

export const SidePanelSectionDivider = styled(Box)(() => ({
  borderBottom: '1px solid #e7e8e8',
}));
